function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.46716 20.1707L8.09545 23.2897L7.93752 12.5323L23.779 3.17289L18.1627 0L2.23265 9.57955L2.46716 20.1707Z",
  fill: "#FF6600"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.9093 30.5019L27.8184 24.2053L18.1173 29.6847L2.21829 20.7327L1.95985 26.7225L18.1292 36L27.9093 30.5019Z",
  fill: "#FF6600"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.3414 3.48901L18.8136 6.71341L28.5148 12.1951L28.5411 30.1436L33.9708 27.3665L34.0976 9.02459L24.3414 3.48901Z",
  fill: "#FF6600"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.9016 26.4954L24.3055 32.6679C20.6275 33.6279 16.9471 34.5833 13.2667 35.541C8.84685 31.1529 4.42223 26.767 0 22.3812C0.641319 20.3884 1.27785 18.3957 1.91678 16.403L14.9968 29.1672L25.9495 26.294L25.8992 26.4907L25.9016 26.4954ZM24.1045 32.4735L25.6121 26.6359L14.925 29.4388L2.02925 16.8526L0.277586 22.3156L13.3409 35.2718L24.1021 32.4712L24.1045 32.4735ZM21.6804 7.17471L27.9404 5.43957C30.6278 8.07857 33.3127 10.7199 36.0024 13.3566C34.3321 19.2973 32.6642 25.2379 30.9915 31.1786C28.9096 31.6329 26.8253 32.0872 24.7434 32.5414L29.5007 15.0753L21.4818 7.22857L21.6828 7.17237L21.6804 7.17471ZM27.8687 5.70886L21.9484 7.35033L29.7711 15.0051L25.0832 32.2253L30.7953 30.9796L35.7296 13.4292L27.871 5.70886H27.8687ZM2.22786 16.1852C3.09891 12.7126 3.96995 9.23767 4.83621 5.76272C10.857 4.01587 16.8777 2.262 22.8936 0.503447L27.6772 5.18434L9.77054 10.2516L7.04015 20.8193L2.22786 16.1852ZM2.49827 16.1103L6.90614 20.3557L9.56474 10.0596L27.2082 5.06726L22.8219 0.775075L5.03962 5.95473L2.49827 16.1103Z",
  fill: "black"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M48.901 24.5V12.43H53.644C56.415 12.43 57.639 13.569 57.639 15.371C57.639 16.357 57.265 17.445 55.786 18.006V18.04C57.673 18.533 58.268 19.689 58.268 21.1C58.268 23.072 57.01 24.5 54.273 24.5H48.901ZM52.029 17.19H53.338C54.086 17.19 54.443 16.833 54.443 16.221C54.443 15.643 54.205 15.235 53.151 15.235H52.029V17.19ZM52.029 21.729H53.695C54.477 21.729 54.919 21.338 54.919 20.624C54.919 19.944 54.477 19.553 53.695 19.553H52.029V21.729Z",
  fill: "#FF6600"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M59.5256 24.5V12.43H67.5496V15.303H62.6536V17.122H66.4786V19.876H62.6536V21.627H67.9066V24.5H59.5256Z",
  fill: "#FF6600"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M76.1641 24.5L72.4071 12.43H75.8581L77.6091 19.196H77.6601L79.2751 12.43H82.6751L84.2561 19.179H84.3071L86.0581 12.43H89.5091L85.7521 24.5H82.8111L81.0261 17.156H80.9921L79.1051 24.5H76.1641Z",
  fill: "#FF6600"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M95.7723 24.67C92.0663 24.67 89.4993 22.137 89.4993 18.465C89.4993 14.793 92.0663 12.243 95.7723 12.243C99.4443 12.243 102.045 14.759 102.045 18.465C102.045 22.154 99.4443 24.67 95.7723 24.67ZM95.7723 21.661C97.4723 21.661 98.6453 20.25 98.6453 18.465C98.6453 16.697 97.4723 15.269 95.7723 15.269C94.0893 15.269 92.8993 16.68 92.8993 18.465C92.8993 20.25 94.0893 21.661 95.7723 21.661Z",
  fill: "#FF6600"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M103.454 24.5V12.43H106.718L109.744 18.431H109.778L112.77 12.43H116.051V24.5H112.855V18.567H112.804L110.781 22.324H108.724L106.701 18.533H106.65V24.5H103.454Z",
  fill: "#FF6600"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M116.912 24.5L121.298 12.43H124.392L128.761 24.5H125.395L124.783 22.545H120.907L120.295 24.5H116.912ZM121.74 19.842H123.95L122.862 16.357H122.828L121.74 19.842Z",
  fill: "#FF6600"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M129.634 24.5V12.43H132.711L136.978 19.264L137.012 19.247V12.43H140.191V24.5H137.012L132.83 17.887H132.796V24.5H129.634Z",
  fill: "#FF6600"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 141,
    height: 36,
    viewBox: "0 0 141 36",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

export default __webpack_public_path__ + "static/media/logo-primary.1c40cb62.svg";
export { SvgComponent as ReactComponent };